const directionsUrl = (name, city) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${name}, ${city}, Oklahoma`)}`;

export const shops = [
  {
    id: "cosmic3d",
    signal: 1,
    name: "Cosmic3D",
    city: "Del City",
    address: "Del City, Oklahoma",
    directionsUrl: directionsUrl("Cosmic3D", "Del City"),
    acceptedAnswers: ["Cosmic3D", "Cosmic 3D"],
    claimCode: "COSM-4D7",
    findClue:
      "Look beyond the atmosphere, then add the process that turns a digital design into a physical object. Find the Del City destination whose name combines both ideas.",
    ringRiddle:
      "The Green Lantern Corps divides the universe into numbered sectors. What sector contains Earth?",
    ringAnswer: "Sector 2814",
  },
  {
    id: "bibliotech",
    signal: 2,
    name: "Bibliotech Books & Comics",
    city: "Shawnee",
    address: "Shawnee, Oklahoma",
    directionsUrl: directionsUrl("Bibliotech Books & Comics", "Shawnee"),
    acceptedAnswers: ["Bibliotech", "Biblio Tech"],
    claimCode: "BIBL-8M2",
    findClue:
      "In the heart of Shawnee, knowledge and heroes wait together upon the shelves. Fantasy, science fiction, games, and comics all have a home here. Its name combines a love of books with a touch of technology. Find this signal where stories and imagination meet.",
    ringRiddle:
      "Every Corps has its sacred text, a record of law kept safe on Oa. Name the book that holds every rule a Lantern must follow.",
    ringAnswer: "The Book of Oa",
  },
  {
    id: "edmond-unplugged",
    signal: 3,
    name: "Edmond Unplugged",
    city: "Edmond",
    address: "Edmond, Oklahoma",
    directionsUrl: directionsUrl("Edmond Unplugged", "Edmond"),
    acceptedAnswers: ["Unplugged", "Unplugged Edmond"],
    claimCode: "UNPL-4H6",
    findClue:
      "In the historic heart of Edmond, screens are set aside and adventures begin. Cards are drawn, dice are rolled, and gathering around the table is always encouraged. To find this signal, discover the place where connecting begins by disconnecting.",
    ringRiddle:
      "Before the Guardians trusted living beings with a ring, they built a robotic Corps to patrol the stars — until it turned on them and had to be shut down for good. Name that original, unplugged Corps.",
    ringAnswer: "The Manhunters",
  },
  {
    id: "artzy-fartzy",
    signal: 4,
    name: "Artzy Fartzy Oklahoma",
    city: "Shawnee",
    address: "20 W Main St, Shawnee, Oklahoma 74801",
    directionsUrl: directionsUrl("Artzy Fartzy Oklahoma", "Shawnee"),
    acceptedAnswers: ["Artzy Fartzy", "Artsy Fartsy"],
    claimCode: "ARTZ-6F9",
    findClue:
      "On Main Street in Shawnee, home decor, garden finds, and cute clothes share the shelves under a name that giggles at itself — one playful word for creativity, rhymed with something a little cheekier. Find this signal where whimsy meets home.",
    ringRiddle:
      "Every Lantern's ring must return home to recharge, and every Lantern calls the same planet home base. Name the world where the Guardians keep the Central Power Battery.",
    ringAnswer: "Oa",
  },
];
